import React from "react";
import styles from "../ContactsTable/ContactsTable.module.scss";

const SortArrow = ({ direction }) => {
  if (!direction) return null;
  return (
    <span className={styles.sortArrow}>
      {direction === "asc" ? "▲" : "▼"}
    </span>
  );
};

export default SortArrow;
